// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4d2f4a15","977":"42ab4c17"}[chunkId] + ".chunk.js";
};